import { Injectable } from '@angular/core';
import { AppConfigService } from './core/appConfig.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParamLauncherDto } from '../models/launcher/paramLauncherDto';
import { EnrollmentFeeDiscountsRequest } from '../models/launcher/enrollmentFeeDiscountsRequest';

@Injectable({
  providedIn: 'root'
})
export class LauncerService {

  private url_init_param = '';
  private url_fee_discounts = '';

  constructor(private http: HttpClient, private configService: AppConfigService) { 
    this.url_init_param = this.configService.apiUrl + "/configuration/launcher/param";
    this.url_fee_discounts = this.configService.apiUrl + "/enrollments/fee-discounts";
  }


  public getParamForLauncher(): Observable<any> {
    return this.http.get<any>(this.url_init_param);
  }

  public consultPotentialCalculation(enrollmentFeeDiscountsRequest: EnrollmentFeeDiscountsRequest): Observable<any>{
    return this.http.post<any>(this.url_fee_discounts, enrollmentFeeDiscountsRequest);
  }


}
